import { Outlet, Route, Routes } from "react-router"
import { DataTable } from "src/modules/pe-admin-module/views/dataTable"
import DataForm from "src/modules/pe-admin-module/views/single/DataForm"
import UserResultsForm from "../user-results/UserResultsForm"
import TestIndex from "./TestIndex"
import TestResults from "./TestResults"
import TestResultsContainer from "./TestResultsContainer"
import TestResultTestsList from "./TestResultTestsList"
import UserTestsResults from "./UserTestsResults"
import { component_url } from "src/libs/utilities/links"


const TestsResultsForm = (props:any) :JSX.Element => {      
    return <Routes>
        <Route path={"/"} element={<TestResultsContainer />} >
            <Route index element={<TestIndex />} />
            <Route path="users" element={<Outlet />} >
                <Route index element={<TestResults />} />
                <Route path={":userId"} element={<Outlet />} >
                    <Route index element={<UserResultsForm />} />
                    <Route path={":testId"} element={<UserTestsResults />} />
                </Route>
            </Route>
            <Route path="all-tests" element={<TestResultTestsList link={ component_url("TestsResultsView") + "" } />} >
                <Route path={":testId"} element={<Outlet />} >
                    <Route path="results" element={
                        <DataTable
                            data_type="TestResult"
                        />
                    } />
                    <Route path="results/:id" element={
                        <DataForm
                            data_type="TestResult"
                            route=""
                        />
                    } />
                </Route>
            </Route>
            <Route path="results" element={
                <DataTable
                    data_type="TestResult"
                    paging={` metas: [{key:"test_id" value:"731ba0d0-4c2f-40d6-aabf-5530568152bb"}] `}
                />
            } /> 
            <Route path="results/:id" element={
                <DataForm
                    data_type="TestResult"
                    route=""
                />
            } />
        </Route>
    </Routes>
} 

export default TestsResultsForm